<template>
  <section v-loading="loading">
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="topic-outer xq_common_text">
      
      <!-- 订单基本信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">订单基本信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ orderNumber }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>分类:</span> {{ showValue(detailData.examName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>名称:</span> {{ showValue(detailData.examName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ detailData.payStartTime?formatDate(detailData.payStartTime):'--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>语言标识:</span> {{ showValue(detailData.languageCode) }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 用户基本信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">用户基本信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户ID:</span> {{ showValue(detailData.userId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ showValue(detailData.userName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单邮箱:</span> {{ showValue(detailData.email) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span> {{ showValue(detailData.sexName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>年龄:</span> {{ showValue(detailData.age) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>注册日期:</span> {{ detailData.userCreateTime?formatDate(detailData.userCreateTime):'--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>是否是会员:</span> {{ showValue(detailData.vipStatusValue) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>是否存在欺诈行为:</span> --
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>测评次数:</span> {{showValue(detailData.examCount)}}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>登录频率:</span> --
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>是否使用智能陪伴AI:</span> --
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>是否付费报告下载:</span> {{ detailData.payStatus===10?'是':'否' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户反馈:</span> --
                <div>
                <!-- <a href="javascript:void(0)">心理问卷数据</a> -->
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户自定义标签:</span> 暂无
              </div>
            </el-col> -->
          </el-row>
        </div>
      </div>

      <!-- 测评过程信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">测评过程信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>测评ID:</span> {{ showValue(detailData.examOrderId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>测评类型:</span> {{ showValue(detailData.examName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>答题开始时间:</span> {{ detailData.startTime?formatDate(detailData.startTime):'--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>答题结束时间:</span> {{ detailData.endTime?formatDate(detailData.endTime):'--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>总答题时间:</span> {{ showValue(detailData.examTimes) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>设备类型:</span> {{ showValue(detailData.userAgentDevice) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>浏览器信息:</span> {{ showValue(detailData.userAgent) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>IP地址:</span> {{ showValue(detailData.ip) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>地理位置:</span> {{ showValue(detailData.countryName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>答题环境信息:</span> --
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>异常:</span> --
              </div>
            </el-col>
            
          </el-row>
        </div>
      </div>

      <!-- 测评结果信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">测评结果信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>测评得分:</span> {{ showValue(detailData.examScore) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>测评结果:</span> {{ detailData.assessmentResult?detailData.assessmentResult.replace(/,/g, ''):'--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>答题时间:</span> {{ showValue(detailData.examTimes) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <div>各维度得分:</div> 
                <div v-if="detailData.scoreEachDimension">
                  <div v-for="(item,index) in detailData.scoreEachDimension" :key="index">
                    {{item.name}}：{{item.value}}
                  </div>
                </div>
                <div v-else>--</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>测评有效性检查:</span> --
              </div>
            </el-col>
                      
          </el-row>
        </div>
      </div>

      <!-- 支付及订阅信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">支付及订阅信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付ID:</span>
                {{ showValue(detailData.transactionId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付订单号:</span>
                {{ showValue(orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ showValue(detailData.paymentType) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
                $ {{ showValue(detailData.payMoney ? detailData.payMoney / 100 : 0) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <el-tag type="warning" effect="dark" size="mini" v-if="detailData.payStatus == 0">待支付</el-tag>
                <el-tag type="info" effect="dark" size="mini" v-if="detailData.payStatus == 3">取消支付</el-tag>
                <el-tag type="warning" effect="dark" size="mini" v-if="detailData.payStatus == 5">支付确认中</el-tag>
                <el-tag type="success" effect="dark" size="mini" v-if="detailData.payStatus == 10">支付成功</el-tag>
                <el-tag type="danger" effect="dark" size="mini" v-if="detailData.payStatus == 15">支付失败</el-tag>
                <el-tag type="warning" effect="dark" size="mini" v-if="detailData.payStatus == 20">退款中</el-tag>
                <el-tag type="success" effect="dark" size="mini" v-if="detailData.payStatus == 25">退款完成</el-tag>
                    
                
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订阅状态:</span> {{ showValue(detailData.subscriptionStatusValue) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.payStatus === '支付失败'">
              <div class="grid-content bg-purple">
                <span>支付失败原因:</span>
                --
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>首次支付时间:</span>
                {{ detailData.payStartTime?formatDate(detailData.payStartTime):'--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下次扣费日期:</span>
                {{ showValue(detailData.nextBillingDate) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付风险评分:</span>
                --
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>订阅ID:</span>
                {{ showValue(detailData.renewalTotal.subscriptionId) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>续费期数:</span>
                {{ showValue(detailData.renewalTotal.renewalCount) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>交易ID:</span>
                {{ showValue(detailData.renewalTotal.transactionId || detailData.transactionId) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>支付平台订阅ID:</span>
                {{ showValue(detailData.renewalTotal.paymentSubscriptionId) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>货币:</span>
                {{ showValue(detailData.renewalTotal.currey) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>累计支付金额:</span>
                $ {{ showValue(detailData.renewalTotal.paymentCount) }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.renewalTotal">
              <div class="grid-content bg-purple">
                <span>下次扣费时间:</span>
                {{ detailData.renewalTotal.nextTime?formatDate(detailData.renewalTotal.nextTime):'--' }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 续订记录 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">续订记录</div>
        <div class="innner">
          <el-row>
            <el-table
                :data="detailData.renewalRecords || []"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
            <el-table-column
                  label="订单 ID"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column
                  label="续费日期"
                  prop="utime"
                  min-width="160"
              ></el-table-column>
              <el-table-column label="金额" prop="amount">
                <template slot-scope="scope">
                  $ {{ showValue(scope.row.amount)}}
                </template>
              </el-table-column>
              <el-table-column
                  label="状态"
                  prop="flowStatus"
              >
                <template slot-scope="scope">
                  {{ scope.row.flowStatus === 'SUCCESS' ? '支付成功' : '支付失败' }}
                </template>
              </el-table-column>             
            </el-table>
          </el-row>
        </div>
      </div>

      <!-- 续订总计 -->
      <div class="appraisal-center fonts tab_info_casertyudsad" v-if="detailData.renewalTotal">
        <div class="xq_common_textTitle">续订总计</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订阅ID:</span>
                {{ showValue(detailData.renewalTotal.subscriptionId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>续费期数:</span>
                {{ showValue(detailData.renewalTotal.renewalCount) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>交易ID:</span>
                {{ showValue(detailData.renewalTotal.transactionId || detailData.transactionId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付平台订阅ID:</span>
                {{ showValue(detailData.renewalTotal.paymentSubscriptionId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>货币:</span>
                {{ showValue(detailData.renewalTotal.currey) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>累计支付金额:</span>
                $ {{ showValue(detailData.renewalTotal.paymentCount) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下次扣费时间:</span>
                {{ detailData.renewalTotal.nextTime?formatDate(detailData.renewalTotal.nextTime):'--' }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 营销与渠道信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">营销与渠道信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>推广渠道:</span>
                {{ showValue(detailData.attributionChannel) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户来源URL:</span>
                {{ showValue(detailData.channelUrl) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ showValue(detailData.belongingApplication) }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span>
                {{ showValue(detailData.channelType) }}
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span>
                {{ showValue(detailData.paymentName) }}
              </div>
            </el-col> -->
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ showValue(detailData.putWayName) }}
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                {{ showValue(detailData.channelMchVo && detailData.channelMchVo.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>活动ID:</span>
                暂无
              </div>
            </el-col> -->
          </el-row>
        </div>
      </div>

      <!-- 已购SKU信息 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">已购SKU信息</div>
        <div class="innner">
          <el-row>
            <el-table
                :data="detailData.skus || []"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column
                  label="名称"
                  prop="name"
                  width="140"
              ></el-table-column>
              <el-table-column
                  label="国家/地区标识"
                  prop="countryCode"
                  width="150"
              ></el-table-column>
              <el-table-column label="价格" prop="payMoney" width="100">
                <template slot-scope="scope">
                  $ {{ showValue(scope.row.payPrice) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="权益" prop="payMoney" >
                <template slot-scope="scope">
                  <span v-for="(item,index) in scope.row.skuList" :key="index">
                    {{item.name}} 、
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
      </div>

      <!-- 拒付或退款 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">拒付或退款历史</div>
        <div class="innner">
        --
          <!-- 暂时没有相关数据结构，保持原样 -->
        </div>
      </div>

      <!-- 数据隐私 -->
      <div class="appraisal-center fonts tab_info_casertyudsad">
        <div class="xq_common_textTitle">数据隐私</div>
        <div class="xq_common_textTitle">数据处理协议版本：--</div>
        <div class="innner">
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import {emptyShow} from "../../../utils/tools/index";
import OperationConfirmation from "../../../components/OperationConfirmation";
import { formatDate } from "@/utils/filters/filter";
export default {
  components: {
    // itemsDetail,
    OperationConfirmation
  },
  data() {
    return {
      loading: false,
      emptyShow,
      title: "",
      orderNumber:"",
      detailData: {},
      formatDate,
    };
  },
  computed: {

  },
  activated() {
    this.getOrgData();
  },
  created() {
    this.orderNumber = JSON.parse(this.$route.query.value);
    
    this.getOrgData();
  },
  watch: {
    $route(to, form) {
      if (to.query.value) {
        let toOrderNum = JSON.parse(to.query.value)
        let formOrderNum = JSON.parse(form.query.value)
        if (toOrderNum != formOrderNum) {
          this.getOrgData();
        }
      }
    }
  },
  methods: {
    // 处理空值显示"--"
    showValue(value) {
      if (typeof value === "undefined" || value === null || value === "" || value === "null") {
        return "--";
      } else {
        return value;
      }
    },
    /* 返回上一页 */
    goBack() {
      this.$router.go(-1);
    },
    /* 接收参数并获取初始值 */
    async getOrgData() {
      try {
        this.loading = true;
        this.title = this.$route.query.title;
        
        const {data: res} = await this.$get(
              `/exam/order/infoV3?orderNumber=${this.orderNumber}`
          );
          if (res && res.data) {
            this.detailData = res.data;
          } else {
            this.detailData = {};
            console.warn('获取订单详情失败: 响应数据为空');
          }
          
      } catch (error) {
        console.error('获取订单详情失败:', error);
        this.detailData = {};
        this.$message.error('获取订单详情失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}

::v-deep .el-page-header__content {
  font-size: 16px;
  color: #303133;
}

.topic-outer {
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
  // padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .appraisal-center {
    margin: 20px 0;
    border-radius: 6px;
    background: #fff;
    padding: 30px 20px;

    .innner {
      padding: 20px 20px 0;

      .grid-content {
        color: #888;

        span:first-child {
          color: #444;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
//  箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: white !important;
}

// 箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: white !important;
}

// 内容
.testtooltip {
  background: white !important;
  box-shadow: 1px 1px 10px 3px #d3d3d6;
}
</style>

